import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { FooterSection, LeadingTitle, Accordion } from '@components'
import './DebitCardDetail.scss'
import { DebitCardAPI, ShortDescriptionAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import CardSection from '../../../common/components/Cards/CardSection'
import CardHover from '../../../common/components/Cards/CardHover'
import BenefitCard from '../../../common/components/BenefitCard'
import StyledTable from '../../../common/components/StyledTable/StyledTable'

const DebitCardDetailContainer = styled.div`
  background-color: #f9f9f9;
  padding-top: 70px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const Span = styled.span`
  font-size: 14px;
  line-height: 150%;
  color: rgb(242, 169, 0);
`

const H1 = styled.h1`
  font-weight: bold;
  font-size: 20px;
  line-height: 30px;
`

const H2 = styled.h2`
  font-family: KBFGDisplay;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 30px;
  color: black;
`
const P = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: rgb(94, 81, 77);
`

const Img = styled.img`
  width: 100%;
  height: 240px;
  border-radius: 12px 0px 12px 12px;
  object-fit: cover;
  @media (min-width: 992px) {
    height: 343px;
  }
`

const colorCardArray = ['#85714D', '#8A8D8F', '#5E514D']

const DebitCardDetail = function () {
  const { t } = useTranslation()

  const { id } = useParams()
  const [data, setdata] = useState({})
  const [dataDebit, setDataDebit] = useState([])
  const [isLoading, setisLoading] = useState(false)

  useEffect(() => {
    setisLoading(true)
    const loadData = async function () {
      const reportData = await DebitCardAPI(`/${id}`)
      let { data } = reportData.data

      data['blockDataManfaatKartu'] = data.blockDataManfaatKartu.map((x) => {
        return {
          title: x.titleManfaatKartu,
          icon: x.iconManfaatKartu,
        }
      })

      setdata(data)
      loadDataDebit()
    }

    const loadDataDebit = async function () {
      const reportData = await DebitCardAPI('')
      setDataDebit(reportData.data.data)
      setisLoading(false)
    }

    loadData()
  }, [])

  return (
    <DebitCardDetailContainer>
      <div className="p-0 m-0 container-fluid">
        <div className="pt-4 px-3 pb-0">
          <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex position-relative row">
            <div className="position-relative p-0 order-lg-2 mb-lg-5 col-lg-9 col-12">
              <Desktop>
                <Img src={data.imageBannerDesktop} />
              </Desktop>
              <Mobile>
                <Img src={data.imageBannerMobile} />
              </Mobile>
              <div className="position-relative">
                <div className="py-4 px-3 px-lg-4 myContainer">
                  <Desktop>
                    <CardSection
                      title={data.title}
                      description={data.description}
                      textButton={t('dapatkan_sekarang')}
                      // linkButton={'/'}
                      url={data.imageCardDesktop}
                      // showButton={true}
                      />
                  </Desktop>

                  <Mobile>
                    <CardSection
                      title={data.title}
                      description={data.description}
                      textButton={t('dapatkan_sekarang')}
                      // linkButton={'/'}
                      url={data.imageCardMobile}
                      // showButton={true}
                    />
                  </Mobile>

                  {typeof data.blockDataManfaatKartu != 'undefined' &&
                    data.blockDataManfaatKartu.length > 0 && (
                      <div className="container-fluid">
                        <div className="mb-4 mt-4 flex align-items-center position-relative row">
                          <BenefitCard
                            title={t('manfaat_kartu')}
                            items={isLoading ? [] : data.blockDataManfaatKartu}
                          />
                        </div>
                      </div>
                    )}

                  {typeof data.detailCard != 'undefined' &&
                    data.detailCard.length > 0 && (
                      <div>
                        {data.id == 1171 || data.id == 1935 ? (
                          <div className="row mt-4">
                            <div className="col-12">
                              <H2>{t('detail_kartu')}</H2>
                              <P
                                className="list"
                                dangerouslySetInnerHTML={{
                                  __html: data.detailCard,
                                }}
                              ></P>
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    )}

                  {typeof data.blockJenisKartu != 'undefined' &&
                    data.blockJenisKartu.length > 0 && (
                      <div className="row mt-4">
                        <div className="col-12">
                          <H2>{t('jenis_kartu')}</H2>
                        </div>

                        {data.blockJenisKartu.map((item, index) => {
                          const colorIndex = index % colorCardArray.length
                          const color = colorCardArray[colorIndex]

                          return (
                            <div className="col-lg-4 mt-4">
                              <div
                                style={{
                                  background: color,
                                  borderRadius: '0px 24px',
                                  padding: '20px',
                                  textAlign: 'center',
                                  minHeight: '450px',
                                }}
                              >
                                <h3
                                  style={{
                                    fontStyle: 'normal',
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    textAlign: 'center',
                                    color: 'white',
                                    marginTop: '12px',
                                  }}
                                >
                                  {item.titleJenisKartu}
                                </h3>
                                <h5
                                  style={{
                                    fontStyle: 'normal',
                                    fontWeight: 'bold',
                                    fontSize: '12px',
                                    lineHeight: '18px',
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    marginTop: '12px',
                                    textAlign: 'left',
                                  }}
                                >
                                  {t('untuk_nasabah')} :
                                </h5>
                                <span
                                  style={{
                                    textAlign: 'left',
                                    fontSize: '12px',
                                  }}
                                  className="list2"
                                  dangerouslySetInnerHTML={{
                                    __html: item.contentJeniskartu,
                                  }}
                                ></span>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    )}

                  {typeof data.blockDataPriceAndLimitation != 'undefined' &&
                    data.blockDataPriceAndLimitation.length > 0 && (
                      <div className="row mt-4">
                        <div className="col-12">
                          <H2>{t('biaya_limitasi_kartu')}</H2>
                          {isLoading
                            ? []
                            : data.blockDataPriceAndLimitation.map((item) => {
                                return (
                                  <StyledTable>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item.contentPriceAndLimitation,
                                      }}
                                    ></div>
                                  </StyledTable>
                                )
                              })}
                        </div>
                      </div>
                    )}

                  {data.id == 1936 &&
                    typeof data.detailCard != 'undefined' &&
                    data.detailCard.length > 0 && (
                      <div className="row mt-4">
                        <div className="col-12">
                          <H2>{t('detail_kartu')}</H2>
                          <Accordion title={t('persyaratan')}>
                            {data.detailCard}
                          </Accordion>
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="order-lg-1 px-3 pe-lg-4 col-lg-3 col-12">
              <Span>{t('your_daily_solution')}</Span>
              <H1>{data.title}</H1>
              <p
                className="mb-3"
                style={{
                  color: 'rgb(138, 141, 143)',
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  fontSize: '14px',
                  lineHeight: '150%',
                }}
              >
                {t('kartu_debit_lainnya')}
              </p>
              {isLoading
                ? []
                : dataDebit.map((item) => {
                    return (
                      <CardHover
                        title={item.title}
                        url={item.imageCardDesktop}
                        link={'/debit-card/' + item.id}
                      />
                    )
                  })}
            </div>
          </div>
        </div>
      </div>
      <FooterSection currentPage={t('kartu_debit')} />
    </DebitCardDetailContainer>
  )
}

export default DebitCardDetail
